import React from 'react';
import { useId } from '@sail/react-aria';
import { createView, view } from '@sail/ui';
import { helmTokens } from '../../theme';
export const AreaChart = createView((props)=>{
    const id = useId();
    return /*#__PURE__*/ React.createElement(view.svg, {
        viewBox: "0 0 39 37",
        xmlns: "http://www.w3.org/2000/svg",
        width: "39",
        height: "37",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `areaChartIconClipPath-${id}-a`
    }, /*#__PURE__*/ React.createElement(view.path, {
        d: "M1.55 35.68l12.32-6.4a1 1 0 0 0 .44-.45L24.8 6.7a1 1 0 0 1 1.56-.33l12.3 10.64a1 1 0 0 1 .34.76V33a4 4 0 0 1-4 4H1.87a.7.7 0 0 1-.32-1.32z",
        css: {
            fill: `${helmTokens.color.blendBackground}`
        }
    }))), /*#__PURE__*/ React.createElement(view.path, {
        d: "M1.55 35.68l12.32-6.4a1 1 0 0 0 .44-.45L24.8 6.7a1 1 0 0 1 1.56-.33l12.3 10.64a1 1 0 0 1 .34.76V33a4 4 0 0 1-4 4H1.87a.7.7 0 0 1-.32-1.32z",
        css: {
            fill: `${helmTokens.color.blendBackground}`
        }
    }), /*#__PURE__*/ React.createElement(view.path, {
        d: "M.76 34.6L12.1 19.26a1 1 0 0 1 1.09-.37l11.65 3.4a1 1 0 0 0 1.17-.5L37.1.6a1 1 0 0 1 1.89.46V33a4 4 0 0 1-4 4H1.97a1.5 1.5 0 0 1-1.2-2.4z",
        css: {
            fill: `${helmTokens.color.blendForeground}`
        }
    }), /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#areaChartIconClipPath-${id}-a)`
    }, /*#__PURE__*/ React.createElement(view.path, {
        d: "M.76 34.6L12.1 19.26a1 1 0 0 1 1.09-.37l11.65 3.4a1 1 0 0 0 1.17-.5L37.1.6a1 1 0 0 1 1.89.46V33a4 4 0 0 1-4 4H1.97a1.5 1.5 0 0 1-1.2-2.4z",
        css: {
            fill: `${helmTokens.color.blendIntersection}`
        }
    })));
});

//# sourceMappingURL=AreaChart.js.map